import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AdaCustomizationsService } from 'core/services';
import { Observable, of } from 'rxjs';
import { MarsGroup } from '../../mars/models/MarsGroup';

export const CustomizationResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  adaCustomizationsService: AdaCustomizationsService = inject(AdaCustomizationsService)
): Observable<MarsGroup> => {
  const customizationId = route.paramMap.get('id') || route.queryParamMap.get('id');

  if (customizationId) {
    return adaCustomizationsService.getCustomization(customizationId);
  }

  return of(null as any);
};
